export default (state = {}, newState = {}) => {
    return Object.assign({}, state, newState);
};